import { html } from 'lit';
import { MobxLitElement } from '@adobe/lit-mobx';
import { customElement } from 'lit/decorators.js';
import '@digital-realty/ix-icon-button/ix-icon-button.js';
import '@digital-realty/ix-switch/ix-switch.js';
import { TWStyles } from '../../tw.js';
import { NotificationsState } from '../../state/NotificationState.js';
import { NotificationGroups } from '../../constants/notifications.js';
import { NotificationsStyle } from '../../styles/notifications-style.js';

@customElement('group-filters')
export class GroupFilters extends MobxLitElement {
  static get styles() {
    return [TWStyles, NotificationsStyle];
  }

  onSwitchChange(e: Event) {
    const target = e.target as any;
    const groupName = target.attributes.getNamedItem('name')?.value;

    NotificationsState.setNotificationFilter(groupName, target.selected);
    this.requestUpdate();
  }

  render() {
    return html` <div class="flex flex-col">
      <label
        class="whitespace-nowrap p-2 flex gap-3 items-center hover:bg-primary-subtle"
      >
        <ix-switch
          data-testid="planned-maintenance-switch"
          class="flex"
          name=${NotificationGroups.PLANNED_MAINTENANCE}
          selected=${NotificationsState.notificationFilters
            .SHOW_PLANNED_MAINTENANCE}
          @change=${this.onSwitchChange}
        ></ix-switch>
        <span>Planned Maintenance</span></label
      >
      <label
        class="whitespace-nowrap p-2 flex gap-3 items-center hover:bg-primary-subtle"
      >
        <ix-switch
          data-testid="service-tickets-switch"
          class="flex"
          name=${NotificationGroups.SERVICE_TICKETS}
          selected=${NotificationsState.notificationFilters
            .SHOW_SERVICE_TICKETS}
          @change=${this.onSwitchChange}
        ></ix-switch>
        <span>Service Ticket Updates</span></label
      >
      <label
        class="whitespace-nowrap p-2 flex gap-3 items-center hover:bg-primary-subtle"
      >
        <ix-switch
          data-testid="dcim-alerts-switch"
          class="flex"
          name=${NotificationGroups.DCIM_ALERTS}
          selected=${NotificationsState.notificationFilters.SHOW_DCIM_ALERTS}
          @change=${this.onSwitchChange}
        ></ix-switch>
        <span>${NotificationGroups.DCIM_ALERTS}</span></label
      >
    </div>`;
  }
}
